const y = {
  mounted(s, n) {
    let r = n.value;
    if (!r) {
      const e = s.getRootNode();
      if (e instanceof ShadowRoot)
        r = e;
      else
        return;
    }
    const i = [], d = (e) => {
      for (const t of Array.from(e))
        window.CSSPropertyRule && t instanceof CSSPropertyRule && i.push({
          name: t.name,
          initialValue: t.initialValue || "initial"
        });
    }, a = () => {
      i.length = 0, r.styleSheets && Array.from(r.styleSheets).forEach((e) => {
        try {
          d(e.cssRules);
        } catch (t) {
        }
      });
    };
    a();
    const c = () => {
      if (i.length > 0) {
        const t = `
          *,
          :before,
          :after,
          ::backdrop {
            ${i.map((l) => `  ${l.name}: ${l.initialValue};`).join(`
`)}
          }
        `.trim();
        let o = r.querySelector("#shadow-property-polyfill");
        o || (o = document.createElement("style"), o.id = "shadow-property-polyfill", r.prepend(o)), o.textContent = t;
      }
    };
    c();
    const f = new MutationObserver((e) => {
      let t = !1;
      for (const o of e)
        o.type === "childList" && o.addedNodes.forEach((l) => {
          l instanceof HTMLStyleElement && (t = !0);
        });
      t && (a(), c());
    });
    f.observe(r, { childList: !0 }), setTimeout(() => {
      a(), c();
    }, 500), s.__shadowPropertyObserver = f;
  },
  beforeUnmount(s) {
    const n = s.__shadowPropertyObserver;
    n && (n.disconnect(), delete s.__shadowPropertyObserver);
  }
};
export {
  y as vShadowPropertyPolyfill
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/utils/vShadowPropertyPolyfill.js
// module id = 155
// module chunks = 67